module.exports = __webpack_public_path__ + "img/media-6.9215a20f.png";